import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const AsendiaCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
  carrierFacility: input<string>(),
  subAccountNumber: input<string>(),
});

export type AsendiaCarrierValue = InputProvider.Value<
  typeof AsendiaCarrierInput
>;

export type AsendiaCarrierForm = InputProvider.Form<typeof AsendiaCarrierInput>;

export const asendiaCarrierDefault = (): AsendiaCarrierValue => ({
  accountNumber: "",
  password: "",
  username: "",
  apiKey: "",
  carrierFacility: "",
  subAccountNumber: "",
});

export const CreateAsendiaCarrierForm = memo(function CreateAsendiaCarrierForm({
  carrierInput,
}: {
  carrierInput: AsendiaCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Account Number"
        placeholder=""
        setValue={carrierInput.inputs.accountNumber.setValue}
        value={carrierInput.inputs.accountNumber.value}
      />
      <RedoTextInput
        inputTypeHint="password"
        label="Password"
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
      <RedoTextInput
        label="Username"
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
      <RedoTextInput
        label="API Key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
      <RedoTextInput
        label="Carrier facility (optional)"
        placeholder=""
        setValue={carrierInput.inputs.carrierFacility.setValue}
        value={carrierInput.inputs.carrierFacility.value}
      />
      <RedoTextInput
        label="Sub account number (optional)"
        placeholder=""
        setValue={carrierInput.inputs.subAccountNumber.setValue}
        value={carrierInput.inputs.subAccountNumber.value}
      />
    </>
  );
});
